import React, { Fragment } from 'react';
import { connect } from 'dva';
import { t, Trans } from '@lingui/macro';
import Checkbox from '@mos-cat/checkbox';
import { Dispatch } from 'redux';

import { AGREEMENTS_FIELD_NAME } from '../../../constants/fieldNames';
import { getOnChange } from '../../../helpers/handlers';
import MosSelect from '@mos-front-components/public/es/components/MosSelect/MosSelect';
import { Field } from '../../../declarations/widget-ums';
import './PaperCertificate.pcss';
import { paperCertificateSelector } from '../../../selectors/submit';
import { i18n } from '../../../helpers/i18n';
import { AGREEMENTS } from '../../../constants/modelNames';

interface PaperCertificateProps {
  needPaperCertificate: Field<boolean>;
  centerPGU: Field<string>;
  onChange(e): void;
}

function PaperCertificate({
  needPaperCertificate,
  centerPGU,
  onChange,
}: PaperCertificateProps) {
  const {
    needPaperCertificate: needPaperCertificateName,
    centerPGU: centerPGUName,
  } = AGREEMENTS_FIELD_NAME;

  // Returning null until further notice

  return null;

  return (
    <div className="StepContentBlock">
      <div className="PguFormGrid__row">
        <Checkbox
          label={i18n._(
            t`Получить Удостоверения многодетной семьи города Москвы на бумажном носителе при личном приходе в выбранный центр госуслуг.`
          )}
          name={needPaperCertificateName}
          {...needPaperCertificate}
          onChange={onChange}
        />
      </div>
      {needPaperCertificate.value && (
        <Fragment>
          <div className="PguFormGrid__row">
            <MosSelect
              className="PaperCertificateSelect"
              name={centerPGUName}
              placeholder={i18n._(t`Центр госуслуг`)}
              suggestions={[]}
              {...centerPGU}
              hasError={centerPGU.error}
              onChange={(value) =>
                onChange({ target: { name: centerPGUName, value } })
              }
              onInputChange={() => {}}
            />
          </div>
          <button className="mos-link">
            <Trans>Выбрать на карте</Trans>
          </button>
        </Fragment>
      )}
    </div>
  );
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onChange: getOnChange(AGREEMENTS, dispatch),
});

export default connect(
  paperCertificateSelector,
  mapDispatchToProps
)(PaperCertificate);
